import React, { useEffect } from 'react'
import CloseButton from 'components/CloseButton'
import AddUserModalForm from './Form'
import AddUserModalError from './Error'
import AddUserModalSummary from './Summary'
import { AddUserModalContainer } from './AddUserModal.styles'
import CloseIcon from 'components/CloseIcon'
import { Site, SiteUser } from 'types'

type BulkAddUsersResponse = {
  newSiteUsers?: SiteUser[]
  failedSiteUsers?: SiteUser[]
  invalidSiteUsers?: SiteUser[]
  sendEmail?: boolean
}

type ErrorWithResponse = Error & {
  response?: {
    status?: number
    statusText?: string
    data?: any
  }
  status?: number
  statusText?: string
  detail?: string
}

interface AddUserModalProps {
  closeModal: () => void
  error?: ErrorWithResponse
  isBulkOperationCompleted?: boolean
  addBulkUsersResponse?: BulkAddUsersResponse | null
  handleOpenAddUsersModal: () => void
  isModalOpen: boolean
  handleSubmitAddUsers: (
    emails: string[],
    role: string,
    sendNotification: boolean,
    inputMode: string,
  ) => Promise<void>
  selectedSite?: Site
}

const AddUserModal: React.FC<AddUserModalProps> = ({
  closeModal,
  error,
  isBulkOperationCompleted,
  addBulkUsersResponse,
  handleOpenAddUsersModal,
  isModalOpen,
  handleSubmitAddUsers,
  selectedSite,
}) => {
  useEffect(() => {
    if (addBulkUsersResponse && isBulkOperationCompleted && !isModalOpen) {
      handleOpenAddUsersModal()
    }
  }, [
    addBulkUsersResponse,
    isBulkOperationCompleted,
    isModalOpen,
    handleOpenAddUsersModal,
  ])

  return (
    <AddUserModalContainer
      dataTestId="add-user-content-wrapper"
      isModalOpen={isModalOpen}
    >
      <CloseButton
        dataTestId="close-add-user-modal-button"
        onClick={closeModal}
      >
        <CloseIcon />
      </CloseButton>
      {error && !error.response ? (
        <AddUserModalError error={error} onClose={closeModal} />
      ) : isBulkOperationCompleted && addBulkUsersResponse ? (
        <AddUserModalSummary data={addBulkUsersResponse} onClose={closeModal} />
      ) : (
        <AddUserModalForm
          handleCloseAddUsersModal={closeModal}
          handleSubmitAddUsers={handleSubmitAddUsers}
          selectedSite={selectedSite}
        />
      )}
    </AddUserModalContainer>
  )
}

export default AddUserModal
